// Module
var code = "<svg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.216 14l4.664-4.665a.782.782 0 10-1.107-1.106l-4.665 4.664-.002-.002L10 13.998l.002.002H10l1.106 1.108h.001l4.665 4.663a.78.78 0 001.107 0 .782.782 0 000-1.106L12.216 14z\"/></svg> ";
// Exports
module.exports = code;